(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bfcm-base"] && !Shopify.designMode) return;
  try {
    (function () {
  if (window.BFCM) return;
  var KEY = 'rg_bfcm_2026';
  // Earlier builds kept the sign-up in localStorage; clear it so returning visitors start fresh
  try { localStorage.removeItem(KEY); } catch (e) {}

  var BFCM = window.BFCM = {
    state: null,
    register: function (data) {
      this.state = Object.assign({}, this.state || {}, data || {}, { at: Date.now() });
      this.apply(true);
    },
    reset: function () { this.state = null; this.apply(false); },
    apply: function (fresh) {
      document.documentElement.classList.toggle('bfcm-registered', !!this.state);
      document.dispatchEvent(new CustomEvent('bfcm:state', { detail: { registered: !!this.state, data: this.state, fresh: !!fresh } }));
    },
    // Scroll an element to just below the theme header (Impulse shows its sticky header on scroll-up)
    scrollTo: function (el) {
      var header = document.querySelector('.site-header');
      var offset = header ? Math.min(header.offsetHeight, 240) : 0;
      window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - offset, behavior: 'smooth' });
    },
    // Theme editor only: the hero's "Show the page after sign-up" box previews the registered state
    syncPreview: function () {
      var hero = document.querySelector('[data-bfcm-hero][data-preview-registered]');
      var on = !!(window.Shopify && Shopify.designMode && hero);
      if (on) this.state = { email: 'kimberly.j@gmail.com', alerts: hero.getAttribute('data-alerts-email'), preview: true };
      else if (this.state && this.state.preview) this.state = null;
      this.apply(false);
    },
    jump: function () {
      document.querySelectorAll('dialog[open]').forEach(function (d) { d.close(); });
      var target = document.getElementById('bfcm-signup');
      if (!target) return;
      this.scrollTo(target);
      if (!this.state) {
        setTimeout(function () {
          var field = target.querySelector('[data-bfcm-form] input:not([type=hidden]):not([type=checkbox])');
          if (field) field.focus({ preventScroll: true });
        }, 500);
      }
    }
  };

  function pad(n) { return String(n).padStart(2, '0'); }
  // Local wall time in an IANA zone -> UTC ms (two passes settle daylight-saving edges)
  function zoned(local, tz) {
    var m = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})/.exec(local || '');
    if (!m) return NaN;
    var wall = Date.UTC(+m[1], m[2] - 1, +m[3], +m[4], +m[5]);
    try {
      var f = new Intl.DateTimeFormat('en-US', { timeZone: tz, hourCycle: 'h23', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' });
      var offset = function (ts) {
        var p = {};
        f.formatToParts(new Date(ts)).forEach(function (x) { p[x.type] = x.value; });
        return Date.UTC(+p.year, p.month - 1, +p.day, +p.hour % 24, +p.minute) - ts;
      };
      var ts = wall - offset(wall);
      return wall - offset(ts);
    } catch (e) { return wall; }
  }
  function targetOf(el) {
    var v = el.getAttribute('data-bfcm-countdown'), tz = el.getAttribute('data-bfcm-tz');
    if (v === 'hero') {
      var hero = document.querySelector('[data-bfcm-hero]');
      if (!hero) return NaN;
      v = hero.getAttribute('data-bfcm-at'); tz = hero.getAttribute('data-bfcm-tz');
    }
    return tz ? zoned(v, tz) : Date.parse(v);
  }
  function tick() {
    document.querySelectorAll('[data-bfcm-countdown]').forEach(function (el) {
      var t = targetOf(el);
      if (isNaN(t)) return;
      var s = Math.max(0, Math.floor((t - Date.now()) / 1000));
      var v = { d: Math.floor(s / 86400), h: Math.floor(s % 86400 / 3600), m: Math.floor(s % 3600 / 60), s: s % 60 };
      el.querySelectorAll('[data-u]').forEach(function (b) { b.textContent = pad(v[b.getAttribute('data-u')]); });
      var f = el.getAttribute('data-format');
      if (f) el.textContent = f.replace('[days]', v.d).replace('[hours]', v.h);
      el.toggleAttribute('data-bfcm-done', s === 0);
    });
  }

  function boot() {
    var params = new URLSearchParams(location.search);
    BFCM.state = null;
    // A redirect back with the success parameter shows the pass for this view only
    var hero = document.querySelector('[data-bfcm-hero]');
    var key = hero && hero.getAttribute('data-success-param');
    if (key && params.has(key)) {
      var pending = null;
      try { pending = JSON.parse(sessionStorage.getItem(KEY + '_pending')); sessionStorage.removeItem(KEY + '_pending'); } catch (e) {}
      BFCM.state = Object.assign({ at: Date.now() }, pending || {});
      params.delete(key);
      var q = params.toString();
      history.replaceState(history.state, '', location.pathname + (q ? '?' + q : '') + location.hash);
    }
    if (window.Shopify && Shopify.designMode) BFCM.syncPreview(); else BFCM.apply(false);
    tick();
    setInterval(tick, 1000);
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-bfcm-jump]');
    if (!a) return;
    e.preventDefault();
    BFCM.jump();
  });
  document.addEventListener('shopify:section:load', tick);
  // Back/forward cache restores the page as it was (filled form, or Brevo's thank-you step); reload for a clean form
  window.addEventListener('pageshow', function (e) { if (e.persisted && document.querySelector('[data-bfcm-hero]')) location.reload(); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    (function () {
  'use strict';

  var RG_THRESHOLD = 10000; // $100.00 in cents

  function rgFormatMoney(cents) {
    if (window.theme && theme.Currency && theme.settings && theme.settings.moneyFormat) {
      return theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
    }
    return '$' + Math.round(cents / 100);
  }

  // Read configurable unlocked message from <template> (set from Liquid setting)
  function rgGetUnlockedMsg() {
    var tpl = document.getElementById('rg-unlocked-msg');
    return tpl ? tpl.innerHTML.trim() : '<strong>Free shipping unlocked.</strong>';
  }

  function rgUpdateShippingBar(subtotalCents) {
    var bar = document.querySelector('[data-rg-shipping-bar]');
    if (!bar) return;

    var fill = bar.querySelector('[data-rg-shipping-fill]');
    var message = bar.querySelector('[data-rg-shipping-message]');
    var pct = Math.min(100, (subtotalCents / RG_THRESHOLD) * 100);
    var remaining = Math.max(0, RG_THRESHOLD - subtotalCents);
    var unlocked = remaining <= 0;

    if (fill) {
      fill.style.width = pct + '%';
    }

    if (message) {
      if (unlocked) {
        message.innerHTML = rgGetUnlockedMsg();
      } else {
        message.innerHTML =
          'You\'re <strong class="rg-shipping-bar__amount">' +
          rgFormatMoney(remaining) +
          '</strong> away from <strong>free shipping</strong>.';
      }
    }

    bar.classList.toggle('rg-shipping-bar--unlocked', unlocked);
  }

  function rgUpdateCartCount(count) {
    var el = document.querySelector('[data-rg-cart-count]');
    if (!el) return;
    el.textContent = '(' + count + ' ' + (count === 1 ? 'item' : 'items') + ')';
  }

  function rgUpdateCheckoutPrice(totalCents) {
    var el = document.querySelector('[data-rg-checkout-amount]');
    if (!el) return;
    el.textContent = rgFormatMoney(totalCents);
  }

  // Fires on every qty change in the drawer
  document.addEventListener('cart:updated', function (evt) {
    var cart = evt.detail && evt.detail.cart;
    if (!cart) return;
    rgUpdateShippingBar(cart.total_price);
    rgUpdateCartCount(cart.item_count);
    rgUpdateCheckoutPrice(cart.total_price);
  });

  // Watch [data-products] for buildCart mutations (drawer open, add-to-cart)
  function rgWatchProducts() {
    var productsEl = document.querySelector('[data-products]');
    if (!productsEl) return;

    var observer = new MutationObserver(function () {
      var items = productsEl.querySelector('.cart__items');
      if (!items) return;
      var count = parseInt(items.dataset.count || 0, 10);
      var subtotal = parseInt(items.dataset.cartSubtotal || 0, 10);
      rgUpdateShippingBar(subtotal);
      rgUpdateCartCount(count);
      rgUpdateCheckoutPrice(subtotal);
    });

    observer.observe(productsEl, { childList: true });
  }

  document.addEventListener('shopify:section:load', function (evt) {
    if (evt.target.querySelector && evt.target.querySelector('#CartDrawer')) {
      rgWatchProducts();
    }
  });

  rgWatchProducts();
}());
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-loyalty"] && !Shopify.designMode) return;
  try {
    (function () {
  // Teardown registry — only listeners/observers attached to document/window/body
  // and the body-portaled modal persist across a theme-editor section reload
  // (element-scoped listeners die with their DOM). We collect their removers here
  // so shopify:section:unload can run them.
  var teardown = [];
  function reg(fn) { teardown.push(fn); }
  function onDoc(evt, fn, opts) { document.addEventListener(evt, fn, opts); reg(function () { document.removeEventListener(evt, fn, opts); }); }

  function init() {
  var root = document.querySelector('[data-rg-loyalty]');
  if (!root) return;
  // Guard against double-initialisation (theme editor re-renders, script re-runs).
  if (root.getAttribute('data-rg-loyalty-init') === 'true') return;
  root.setAttribute('data-rg-loyalty-init', 'true');
  teardown = [];
  var configEl = document.querySelector('[data-rg-loyalty-config]');
  if (!configEl) return;

  var CONFIG;
  try { CONFIG = JSON.parse(configEl.textContent); } catch (e) { return; }

  // ---- cart helpers (mirror theme.cart) ----
  // Cache-bust every read: /cart.js sits behind a cache in this setup (the theme
  // appends ?t=Date.now() to every cart fetch too). Without it, a second read of
  // the same URL returns the stale first response — e.g. the earn estimate would
  // stick at the first item's total when a second product is added.
  function getCart() {
    return fetch('/cart.js?t=' + Date.now(), { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { return r.json(); });
  }
  function rebuildCart() {
    // Re-render the drawer's products/discounts/subtotal via the theme.
    document.dispatchEvent(new CustomEvent('cart:build'));
  }

  // ---- membership toggle ----
  var toggle = root.querySelector('[data-rg-membership-toggle]');

  function setToggleState(on) {
    if (!toggle) return;
    toggle.setAttribute('aria-checked', on ? 'true' : 'false');
  }
  function setToggleBusy(busy) {
    if (!toggle) return;
    if (busy) { toggle.setAttribute('aria-busy', 'true'); }
    else { toggle.removeAttribute('aria-busy'); }
  }

  function refreshMembershipFromCart() {
    if (!toggle) return;
    var variantId = String(toggle.getAttribute('data-variant-id'));
    return getCart().then(function (cart) {
      var present = (cart.items || []).some(function (it) { return String(it.variant_id) === variantId; });
      setToggleState(present);
      return cart;
    });
  }

  function addMembership() {
    var variantId = toggle.getAttribute('data-variant-id');
    var sellingPlan = toggle.getAttribute('data-selling-plan');
    var body = { items: [{ id: Number(variantId), quantity: 1 }] };
    if (sellingPlan && sellingPlan !== '') { body.items[0].selling_plan = Number(sellingPlan); }
    return fetch('/cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      // /cart/add.js returns 422 on sold-out / invalid selling_plan — reject so the toggle reverts.
      if (!r.ok) { return r.json().then(function (e) { throw new Error((e && e.description) || 'add failed'); }); }
      return r.json();
    });
  }

  function removeMembership() {
    var variantId = String(toggle.getAttribute('data-variant-id'));
    return getCart().then(function (cart) {
      var item = (cart.items || []).find(function (it) { return String(it.variant_id) === variantId; });
      if (!item) return cart;
      return fetch('/cart/change.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: item.key, quantity: 0 })
      }).then(function (r) {
        if (!r.ok) { return r.json().then(function (e) { throw new Error((e && e.description) || 'remove failed'); }); }
        return r.json();
      });
    });
  }

  if (toggle) {
    // Already a paid member -> show on + lock.
    if (CONFIG.alreadyMember) {
      setToggleState(true);
      toggle.setAttribute('aria-disabled', 'true');
      toggle.setAttribute('aria-busy', 'true'); // visually disabled
    } else {
      setToggleState(!!CONFIG.membershipInCart);
      toggle.addEventListener('click', function () {
        if (toggle.getAttribute('aria-disabled') === 'true') return;
        var turningOn = toggle.getAttribute('aria-checked') !== 'true';
        setToggleBusy(true);
        var action = turningOn ? addMembership() : removeMembership();
        action.then(function () {
          setToggleState(turningOn);
          rebuildCart();
        }).catch(function () {
          // revert on failure
          setToggleState(!turningOn);
        }).then(function () { setToggleBusy(false); });
      });
    }
  }

  // Keep toggle in sync when the cart changes elsewhere. Prefer the event's
  // cart payload to avoid a redundant /cart.js round-trip on every change.
  onDoc('cart:updated', function (e) {
    if (!toggle) return;
    var cart = e && e.detail && e.detail.cart;
    if (cart && cart.items) {
      var variantId = String(toggle.getAttribute('data-variant-id'));
      setToggleState(cart.items.some(function (it) { return String(it.variant_id) === variantId; }));
    } else {
      refreshMembershipFromCart();
    }
  });

  // ---- earn estimate ----
  var earnEl = root.querySelector('[data-rg-earn]');

  function orderEarnRule() {
    return (CONFIG.earnRules || []).find(function (r) { return r.type === 'Place an order'; });
  }
  function earnRate() {
    var rule = orderEarnRule();
    if (!rule) return null;
    // pointsPerActionVipTiers[tier] overrides the base rate, EXCEPT a 0 means
    // "no override for this tier" (e.g. Bronze) — fall back to pointsPerAction.
    var tierRates = rule.pointsPerActionVipTiers;
    var tierRate = tierRates && tierRates[CONFIG.tierLevel];
    var rate = tierRate ? tierRate : rule.pointsPerAction;
    var per = rule.actionConditionAmount || 1; // dollars per "action"
    return { rate: rate, per: per };
  }
  function computeEarn(cartTotalCents) {
    var er = earnRate();
    if (!er) return 0;
    var dollars = (cartTotalCents || 0) / 100;
    return Math.round(dollars * er.rate / er.per);
  }
  function renderEarn(cartTotalCents) {
    if (!earnEl) return;
    var pts = computeEarn(cartTotalCents);
    var tpl = (CONFIG.strings && CONFIG.strings.earnPointsHtml) || '';
    earnEl.innerHTML = tpl.replace('%PTS%', pts);
  }

  renderEarn(CONFIG.cartTotal);

  // Refresh the earn estimate on EVERY cart rebuild, whatever triggered it. Every add
  // path — PDP (ajaxProduct:added), in-drawer qty (cart:updated), third-party upsell
  // widgets (cart:build) — funnels through the theme's buildCart(), which replaces the
  // contents of [data-products]. Keying off the individual events missed paths that
  // don't dispatch them (the upsell updated the subtotal but not the earn line);
  // observing the DOM outcome catches all of them. data-cart-subtotal is
  // cart.total_price (templates/cart.ajax.liquid), the basis used elsewhere. Mirrors
  // rgWatchProducts() in cart-drawer.liquid.
  var earnProductsEl = document.querySelector('#CartDrawer [data-products]')
    || document.querySelector('[data-products]');
  if (earnProductsEl && 'MutationObserver' in window) {
    var earnMo = new MutationObserver(function () {
      var items = earnProductsEl.querySelector('.cart__items');
      if (!items) return;
      renderEarn(parseInt(items.dataset.cartSubtotal || '0', 10));
    });
    earnMo.observe(earnProductsEl, { childList: true });
    reg(function () { earnMo.disconnect(); });
  } else {
    // Fallback: no products container / MutationObserver — hook the known rebuild
    // events and re-fetch the cart (cache-busted) to recompute.
    var refreshEarnFromCart = function () { getCart().then(function (c) { renderEarn(c.total_price); }); };
    onDoc('cart:updated', refreshEarnFromCart);
    onDoc('ajaxProduct:added', refreshEarnFromCart);
    onDoc('cart:build', refreshEarnFromCart);
  }

  // ---- redeem modal controller ----
  var modal = root.querySelector('[data-rg-modal]');
  var openBtn = root.querySelector('[data-rg-redeem-open]');
  var applyBtn = modal && modal.querySelector('[data-rg-apply]');
  var tilesWrap = modal && modal.querySelector('[data-rg-tiles]');
  var sliderPrev = modal && modal.querySelector('[data-rg-slider-prev]');
  var sliderNext = modal && modal.querySelector('[data-rg-slider-next]');
  var emptyEl = modal && modal.querySelector('[data-rg-empty]');
  var dialog = modal && modal.querySelector('.rg-loyalty-modal__dialog');
  var selected = null; // { points, money }
  var lastFocus = null;

  function fillTemplate(tpl, map) {
    var out = tpl || '';
    for (var k in map) { if (map.hasOwnProperty(k)) { out = out.split(k).join(map[k]); } }
    return out;
  }

  // Spend-based tiers store thresholds + vipTierAmountSpent as currency amounts
  // (e.g. dollars). Format via the theme money formatter when available, else
  // fall back to the loyalty config's currency symbol.
  function fmtTierMoney(amount) {
    var cents = Math.round((amount || 0) * 100);
    if (window.theme && theme.Currency && theme.Currency.formatMoney) {
      return theme.Currency.formatMoney(cents, CONFIG.moneyFormat || (theme.settings && theme.settings.moneyFormat));
    }
    var rounded = Math.round((amount || 0) * 100) / 100;
    return (CONFIG.currencySymbol || '$') + rounded;
  }

  function renderTier() {
    if (!modal) return;
    var tiers = CONFIG.vipTiers || [];
    var nameEl = modal.querySelector('[data-rg-tier-name]');
    var remEl = modal.querySelector('[data-rg-tier-remaining]');
    var fillEl = modal.querySelector('[data-rg-tier-fill]');
    var countEl = modal.querySelector('[data-rg-tier-count]');
    var cur = tiers[CONFIG.tierLevel];
    var next = tiers[CONFIG.tierLevel + 1];
    // Tiers are spend-based unless the program is explicitly configured for points.
    var isSpend = CONFIG.tierMode !== 'points';
    var have = isSpend ? (CONFIG.tierAmountSpent || 0) : (CONFIG.tierPoints || 0);
    if (nameEl) nameEl.textContent = cur ? cur.name : '';
    if (next) {
      var threshold = next.threshold;
      var pct = threshold > 0 ? Math.max(0, Math.min(100, (have / threshold) * 100)) : 0;
      if (fillEl) fillEl.style.width = pct + '%';
      var remaining = Math.max(0, threshold - have);
      if (remEl) {
        remEl.textContent = isSpend
          ? fillTemplate(CONFIG.strings.toNextTierSpend, { '%A%': fmtTierMoney(remaining), '%T%': next.name })
          : fillTemplate(CONFIG.strings.toNextTier, { '%P%': remaining, '%T%': next.name });
      }
      if (countEl) {
        countEl.textContent = isSpend
          ? (fmtTierMoney(have) + ' / ' + fmtTierMoney(threshold))
          : (have + '/' + threshold);
      }
    } else {
      if (fillEl) fillEl.style.width = '100%';
      if (remEl) remEl.textContent = CONFIG.strings.maxTier || '';
      if (countEl) countEl.textContent = '';
    }
  }

  function affordableTiles() {
    // Build the list of affordable point multiples from pointsToMoney (keys are points strings).
    var map = CONFIG.pointsToMoney || {};
    var list = [];
    for (var k in map) {
      if (map.hasOwnProperty(k)) {
        var pts = parseInt(k, 10);
        if (pts > 0 && pts <= CONFIG.points) { list.push({ points: pts, money: map[k] }); }
      }
    }
    list.sort(function (a, b) { return a.points - b.points; });
    return list;
  }

  function tileMarkup(tile, isBest, index) {
    var badge = isBest
      ? '<span class="rg-loyalty-tile__badge">' + (CONFIG.strings.bestValue || '') + '</span>'
      : '';
    var cost = fillTemplate(CONFIG.strings.costPoints, { '%P%': tile.points });
    // role=radio + aria-label so SR users hear "$5 off, 100 PTS" per option.
    var label = tile.money + ', ' + cost;
    return '<button type="button" class="rg-loyalty-tile" data-rg-tile data-points="' + tile.points + '" data-money="' + tile.money + '"'
      + ' role="radio" aria-checked="false" aria-label="' + label + '" tabindex="' + (index === 0 ? '0' : '-1') + '">'
      + badge
      + '<span class="rg-loyalty-tile__icon" aria-hidden="true"><svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.4"><path d="M3 11l8-8 10 10-8 8z"/><circle cx="8" cy="8" r="1.4"/></svg></span>'
      + '<span class="rg-loyalty-tile__amount">' + tile.money + '</span>'
      + '<span class="rg-loyalty-tile__cost">' + cost + '</span>'
      + '</button>';
  }

  function renderTiles() {
    if (!tilesWrap) return;
    var tiles = affordableTiles();
    resetSelection();
    if (tiles.length === 0) {
      tilesWrap.innerHTML = '';
      tilesWrap.hidden = true;
      // "You're N points away from your first reward..."
      var away = Math.max(0, CONFIG.redeemCostUnit - CONFIG.points);
      // pointsToMoney only holds AFFORDABLE multiples, so the first-reward amount
      // comes from CONFIG.firstRewardMoney (pre-formatted in Liquid).
      var firstMoney = CONFIG.firstRewardMoney
        || (CONFIG.pointsToMoney && CONFIG.pointsToMoney[CONFIG.redeemCostUnit]) || '';
      emptyEl.innerHTML = fillTemplate(CONFIG.strings.awayFromFirstHtml, { '%P%': away, '%A%': firstMoney });
      emptyEl.hidden = false;
      return;
    }
    tilesWrap.hidden = false;
    emptyEl.hidden = true;
    var maxPoints = tiles[tiles.length - 1].points;
    var html = '';
    for (var i = 0; i < tiles.length; i++) {
      html += tileMarkup(tiles[i], tiles[i].points === maxPoints && tiles.length > 1, i);
    }
    tilesWrap.innerHTML = html;
    // >4 tiles -> horizontal slider with arrows
    var isSlider = tiles.length > 4;
    if (isSlider) { tilesWrap.classList.add('rg-loyalty-modal__tiles--slider'); }
    else { tilesWrap.classList.remove('rg-loyalty-modal__tiles--slider'); }
    setupSlider(isSlider);
  }

  function setupSlider(active) {
    if (!sliderPrev || !sliderNext) return;
    sliderPrev.hidden = !active;
    sliderNext.hidden = !active;
    if (active) { tilesWrap.scrollLeft = 0; updateArrows(); }
  }
  function updateArrows() {
    if (!sliderPrev || !sliderNext || sliderPrev.hidden) return;
    var max = tilesWrap.scrollWidth - tilesWrap.clientWidth - 1;
    sliderPrev.disabled = tilesWrap.scrollLeft <= 0;
    sliderNext.disabled = tilesWrap.scrollLeft >= max;
  }
  function scrollTiles(dir) {
    // Advance by roughly two tiles (one visible "set").
    var step = Math.max(tilesWrap.clientWidth * 0.85, 200);
    tilesWrap.scrollBy({ left: dir * step, behavior: 'smooth' });
  }

  function resetSelection() {
    selected = null;
    if (!applyBtn) return;
    applyBtn.disabled = true;
    applyBtn.textContent = CONFIG.strings.selectReward || 'Select a reward';
    if (tilesWrap) {
      var checked = tilesWrap.querySelectorAll('[aria-checked="true"]');
      for (var i = 0; i < checked.length; i++) { checked[i].setAttribute('aria-checked', 'false'); }
    }
  }

  function selectTile(tileEl) {
    var pts = parseInt(tileEl.getAttribute('data-points'), 10);
    var money = tileEl.getAttribute('data-money');
    selected = { points: pts, money: money };
    var all = tilesWrap.querySelectorAll('[data-rg-tile]');
    // Roving tabindex: only the checked radio is tabbable.
    for (var i = 0; i < all.length; i++) {
      var on = all[i] === tileEl;
      all[i].setAttribute('aria-checked', on ? 'true' : 'false');
      all[i].setAttribute('tabindex', on ? '0' : '-1');
    }
    applyBtn.disabled = false;
    applyBtn.textContent = fillTemplate(CONFIG.strings.applyToCart, { '%A%': money });
  }

  function openModal() {
    if (!modal) return;
    // The cart drawer animates with a CSS transform, which makes it the
    // containing block for our position:fixed modal (trapping it inside the
    // drawer). Portal the modal to <body> so it covers the full viewport.
    if (modal.parentNode !== document.body) { document.body.appendChild(modal); }
    lastFocus = document.activeElement;
    showView('chooser');
    clearApplyError();
    var ptsEl = modal.querySelector('[data-rg-modal-points]');
    if (ptsEl) ptsEl.textContent = CONFIG.points;
    renderTier();
    renderTiles();
    modal.hidden = false;
    document.documentElement.classList.add('rg-loyalty-modal-open');
    if (dialog) dialog.focus();
    document.addEventListener('keydown', onKeydown);
  }
  function closeModal() {
    if (!modal) return;
    modal.hidden = true;
    document.documentElement.classList.remove('rg-loyalty-modal-open');
    document.removeEventListener('keydown', onKeydown);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function onKeydown(e) {
    if (e.key === 'Escape') { closeModal(); return; }
    if (e.key === 'Tab' && dialog) {
      // simple focus trap
      var focusables = dialog.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
      if (!focusables.length) return;
      var first = focusables[0], last = focusables[focusables.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  }

  function showView(name) {
    if (!modal) return;
    var views = modal.querySelectorAll('[data-rg-view]');
    for (var i = 0; i < views.length; i++) {
      views[i].hidden = (views[i].getAttribute('data-rg-view') !== name);
    }
  }

  function setApplyLoading(loading) {
    if (!applyBtn) return;
    applyBtn.disabled = loading;
    applyBtn.setAttribute('aria-busy', loading ? 'true' : 'false');
    if (loading) {
      applyBtn.classList.add('is-loading');
      // Stash the current label so we can restore it if the redeem fails.
      applyBtn.setAttribute('data-rg-prev-label', applyBtn.textContent);
      applyBtn.innerHTML = '<span class="rg-loyalty-spinner" aria-hidden="true"></span>';
    } else {
      applyBtn.classList.remove('is-loading');
      var prev = applyBtn.getAttribute('data-rg-prev-label');
      if (prev != null) { applyBtn.textContent = prev; applyBtn.removeAttribute('data-rg-prev-label'); }
    }
  }

  function showApplyError(msg) {
    var foot = modal.querySelector('[data-rg-view="chooser"] .rg-loyalty-modal__foot');
    if (!foot) return;
    var err = foot.querySelector('[data-rg-apply-error]');
    if (!err) {
      err = document.createElement('p');
      err.setAttribute('data-rg-apply-error', '');
      err.className = 'rg-loyalty-modal__apply-error';
      foot.appendChild(err);
    }
    err.textContent = msg;
  }
  function clearApplyError() {
    var err = modal.querySelector('[data-rg-apply-error]');
    if (err) err.textContent = '';
  }

  function updateBalanceDisplays(newBalance) {
    CONFIG.points = newBalance;
    var modalPts = modal.querySelector('[data-rg-modal-points]');
    if (modalPts) modalPts.textContent = newBalance;
    var rowPts = root.querySelector('[data-rg-points]');
    if (rowPts) rowPts.textContent = newBalance;
  }

  function renderSuccess(money, code, remaining) {
    var headline = modal.querySelector('[data-rg-success-headline]');
    var codeEl = modal.querySelector('[data-rg-success-code]');
    var remEl = modal.querySelector('[data-rg-success-remaining]');
    if (headline) headline.textContent = fillTemplate(CONFIG.strings.offApplied, { '%A%': money });
    if (codeEl) codeEl.textContent = code;
    if (remEl) remEl.textContent = remaining;
    showView('success');
  }

  // The proxy /redeem response shape varies; pull the code/balance from any of
  // the known key spellings (and a possible {data:{...}} envelope).
  function pickCode(d) {
    if (!d) return null;
    var src = d.data && typeof d.data === 'object' ? d.data : d;
    // Confirmed live shape: { newActiveReward: { discountCode: "LOV-…" }, newPointsAvailable }
    return src.discountCode || src.discount_code || src.code
      || (src.newActiveReward && (src.newActiveReward.discountCode || src.newActiveReward.discount_code))
      || (src.discount && (src.discount.code || src.discount.discountCode))
      || null;
  }
  function pickRemaining(d, spent) {
    var src = d && d.data && typeof d.data === 'object' ? d.data : (d || {});
    // newPointsAvailable is returned at the top level of the /redeem response.
    var keys = ['newPointsAvailable', 'pointsAvailable', 'newPoints', 'remainingPoints', 'balance', 'points'];
    for (var i = 0; i < keys.length; i++) {
      if (typeof src[keys[i]] === 'number') return src[keys[i]];
    }
    return Math.max(0, CONFIG.points - spent);
  }

  function doRedeem() {
    if (!selected) return;
    clearApplyError();
    setApplyLoading(true);
    var chosen = selected; // capture
    fetch(CONFIG.proxyBase + '/redeem', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ ruleId: CONFIG.redeemRuleId, amount: chosen.points })
    }).then(function (r) {
      // Read as text first so a non-JSON body doesn't throw into .catch.
      return r.text().then(function (txt) {
        var data = null; try { data = JSON.parse(txt); } catch (e) {}
        return { ok: r.ok, status: r.status, data: data, raw: txt };
      });
    }).then(function (res) {
      var code = pickCode(res.data);
      if (!res.ok || !code) {
        var msg = (res.data && res.data.error)
          ? res.data.error
          : (res.status === 400 ? CONFIG.strings.errorInsufficient : CONFIG.strings.errorGeneric);
        showApplyError(msg);
        setApplyLoading(false);
        return;
      }
      var remaining = pickRemaining(res.data, chosen.points);
      // Apply the minted code to the live cart, then re-render the drawer.
      return fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin' })
        .then(function () {
          updateBalanceDisplays(remaining);
          rebuildCart();
          renderSuccess(chosen.money, code, remaining);
          setApplyLoading(false);
        });
    }).catch(function () {
      showApplyError(CONFIG.strings.errorGeneric);
      setApplyLoading(false);
    });
  }

  function copyCode() {
    var codeEl = modal.querySelector('[data-rg-success-code]');
    var label = modal.querySelector('[data-rg-copy-label]');
    if (!codeEl) return;
    var code = codeEl.textContent;
    var done = function () {
      if (label) {
        label.textContent = CONFIG.strings.copied;
        setTimeout(function () { label.textContent = CONFIG.strings.copy; }, 1800);
      }
    };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(done).catch(function () {});
    } else {
      // Fallback for older browsers
      var ta = document.createElement('textarea');
      ta.value = code; document.body.appendChild(ta); ta.select();
      try { document.execCommand('copy'); done(); } catch (e) {}
      document.body.removeChild(ta);
    }
  }

  if (openBtn) openBtn.addEventListener('click', openModal);
  if (modal) {
    var closers = modal.querySelectorAll('[data-rg-modal-close]');
    for (var c = 0; c < closers.length; c++) { closers[c].addEventListener('click', closeModal); }
    if (tilesWrap) {
      tilesWrap.addEventListener('click', function (e) {
        var t = e.target.closest ? e.target.closest('[data-rg-tile]') : null;
        if (t) selectTile(t);
      });
      tilesWrap.addEventListener('scroll', updateArrows, { passive: true });
      // Radiogroup keyboard nav: arrows move + select, Home/End jump to ends.
      tilesWrap.addEventListener('keydown', function (e) {
        var keys = ['ArrowRight', 'ArrowDown', 'ArrowLeft', 'ArrowUp', 'Home', 'End'];
        if (keys.indexOf(e.key) === -1) return;
        var all = Array.prototype.slice.call(tilesWrap.querySelectorAll('[data-rg-tile]'));
        if (!all.length) return;
        e.preventDefault();
        var cur = all.indexOf(document.activeElement);
        var next;
        if (e.key === 'Home') { next = 0; }
        else if (e.key === 'End') { next = all.length - 1; }
        else if (e.key === 'ArrowRight' || e.key === 'ArrowDown') { next = cur < 0 ? 0 : (cur + 1) % all.length; }
        else { next = cur <= 0 ? all.length - 1 : cur - 1; }
        var el = all[next];
        selectTile(el);
        el.focus();
      });
    }
    if (sliderPrev) sliderPrev.addEventListener('click', function () { scrollTiles(-1); });
    if (sliderNext) sliderNext.addEventListener('click', function () { scrollTiles(1); });
    if (applyBtn) {
      applyBtn.addEventListener('click', doRedeem);
    }
    var copyBtn = modal.querySelector('[data-rg-copy]');
    if (copyBtn) copyBtn.addEventListener('click', copyCode);
  }

  // ---- floating "Membership & Rewards" button ----
  // Shows when the membership OR rewards row scrolls out of the drawer viewport;
  // fades out once they're back in view. Clicking scrolls them into view.
  (function setupFab() {
    var fab = document.querySelector('[data-rg-loyalty-fab]');
    if (!fab) return;
    var dock = document.querySelector('[data-rg-loyalty-fab-dock]');
    var scrollable = root.closest('.drawer__scrollable');
    if (!scrollable) return;
    var membershipRow = root.querySelector('[data-rg-membership]');
    var rewardsRow = root.querySelector('[data-rg-rewards]');
    var shown = null;
    var VISIBLE_RATIO = 0.4; // a row counts as "in view" at >=40% intersection

    function setShown(s) {
      if (s === shown) return;
      shown = s;
      fab.classList.toggle('is-shown', s);
      fab.setAttribute('tabindex', s ? '0' : '-1');
      if (dock) dock.setAttribute('aria-hidden', s ? 'false' : 'true');
    }

    function drawerOpen() {
      return document.documentElement.classList.contains('js-drawer-open') ||
             document.body.classList.contains('js-drawer-open');
    }

    // Track each watched row's current intersection ratio against the scroll
    // viewport. Absent rows aren't tracked (treated as visible). An
    // IntersectionObserver settles correctly AFTER the drawer's open animation
    // and on any layout change, avoiding the stale getBoundingClientRect reads
    // that left the button stuck "shown" on short carts.
    var rows = [membershipRow, rewardsRow].filter(Boolean);
    var ratios = new WeakMap();
    rows.forEach(function (el) { ratios.set(el, 0); });

    function rowVisible(el) {
      if (!el) return true;                       // absent section never forces the button
      if (el.offsetParent === null) return true;  // hidden (empty cart) -> treat as visible
      return ratios.get(el) >= VISIBLE_RATIO;
    }
    function evaluate() {
      if (!drawerOpen()) { setShown(false); return; }     // never show over a closed drawer
      setShown(!(rowVisible(membershipRow) && rowVisible(rewardsRow)));
    }

    var io = null;
    if ('IntersectionObserver' in window && rows.length) {
      io = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          ratios.set(entries[i].target, entries[i].isIntersecting ? entries[i].intersectionRatio : 0);
        }
        evaluate();
      }, { root: scrollable, threshold: [0, VISIBLE_RATIO, 1] });
      rows.forEach(function (el) { io.observe(el); });
      reg(function () { io.disconnect(); });
    } else {
      // Fallback: bounding-box check on scroll/resize (older browsers).
      rowVisible = function (el) {
        if (!el) return true;
        if (el.offsetParent === null) return true;
        var cr = el.getBoundingClientRect(), sr = scrollable.getBoundingClientRect();
        var visibleH = Math.min(cr.bottom, sr.bottom) - Math.max(cr.top, sr.top);
        return cr.height > 0 && (visibleH / cr.height) >= VISIBLE_RATIO;
      };
      var onScroll = (window.theme && theme.utils && theme.utils.throttle)
        ? theme.utils.throttle(100, evaluate)
        : function () { window.requestAnimationFrame(evaluate); };
      scrollable.addEventListener('scroll', onScroll, { passive: true });
      reg(function () { scrollable.removeEventListener('scroll', onScroll, { passive: true }); });
      window.addEventListener('resize', onScroll);
      reg(function () { window.removeEventListener('resize', onScroll); });
    }

    onDoc('cart:updated', function () { setTimeout(evaluate, 80); });
    // Recompute when the drawer opens (display/transform change won't fire scroll).
    // Tag the button as "entering" so its first appearance carries the staggered
    // delay and fades in together with the other drawer components; clear the tag
    // after the entrance so later scroll toggles are immediate. When the drawer
    // closes, force the button hidden so it never lingers over a closed cart.
    var clsMo = new MutationObserver(function () {
      if (drawerOpen()) {
        fab.classList.add('is-entering');
        setTimeout(evaluate, 60);
        setTimeout(function () { fab.classList.remove('is-entering'); }, 1500);
      } else {
        fab.classList.remove('is-entering');
        setShown(false);
      }
    });
    clsMo.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
    clsMo.observe(document.body, { attributes: true, attributeFilter: ['class'] });
    reg(function () { clsMo.disconnect(); });

    fab.addEventListener('click', function () {
      var target = membershipRow || rewardsRow;
      if (target && target.scrollIntoView) {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });

    evaluate();
    setTimeout(evaluate, 200);
  })();

  // Modal is portaled to <body> on open, so it outlives the section's DOM.
  // Register its removal so an editor reload doesn't leave orphaned modals behind.
  if (modal) { reg(function () { if (modal.parentNode) modal.parentNode.removeChild(modal); }); }

  // Expose for later tasks (redeem flow attaches here).
  root.__loyalty = { CONFIG: CONFIG, getCart: getCart, rebuildCart: rebuildCart };
  }

  function cleanup() {
    for (var i = 0; i < teardown.length; i++) {
      try { teardown[i](); } catch (e) {}
    }
    teardown = [];
  }

  init();

  // Theme editor: the cart section's markup is replaced on each edit. Tear down
  // the document/window/body listeners, observer and portaled modal on unload,
  // then re-init on load against the fresh markup. The data-rg-loyalty-init guard
  // keeps a single live instance bound.
  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:unload', cleanup);
    document.addEventListener('shopify:section:load', init);
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-social-proof"] && !Shopify.designMode) return;
  try {
    (function() {
    'use strict';

    function initCartSocialProof(sectionEl) {
      if (!sectionEl) {
        return;
      }

      sectionEl.querySelectorAll('[data-cart-social-proof]').forEach(function(widget) {
        if (widget.dataset.cartSocialProofReady === 'true') {
          return;
        }

        var messageEls = widget.querySelectorAll('[data-cart-social-proof-message]');
        var output = widget.querySelector('[data-cart-social-proof-text]');

        if (!output || messageEls.length < 2) {
          widget.dataset.cartSocialProofReady = 'true';
          return;
        }

        var randomIndex = Math.floor(Math.random() * messageEls.length);
        output.innerHTML = messageEls[randomIndex].innerHTML;
        widget.dataset.cartSocialProofReady = 'true';
      });
    }

    document.addEventListener('shopify:section:load', function(event) {
      initCartSocialProof(event.target);
    });

    document.querySelectorAll('.shopify-section').forEach(function(sectionEl) {
      initCartSocialProof(sectionEl);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["loyalty-points"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('loyalty-points')) {
    customElements.define('loyalty-points', class extends HTMLElement {
      connectedCallback() {
        // Flat (per-order) rules don't change with variant price — leave Liquid value as-is.
        if (this.dataset.relative !== 'true') return;
        this.ppa = parseFloat(this.dataset.pointsPerAction) || 0;
        this.cond = parseFloat(this.dataset.actionCondition) || 1;
        if (this.cond === 0) this.cond = 1;
        this.hideZero = this.dataset.hideWhenZero === 'true';
        this.out = this.querySelector('[data-ll-points]');
        this._h = (e) => {
          var v = e.detail && e.detail.variant;
          if (v && typeof v.price === 'number') this.update(v.price);
        };
        document.addEventListener('variant:change', this._h);
      }
      disconnectedCallback() {
        document.removeEventListener('variant:change', this._h);
      }
      update(priceCents) {
        var pts = Math.floor(priceCents * this.ppa / (this.cond * 100));
        if (this.out) this.out.textContent = pts;
        if (this.hideZero) this.hidden = pts <= 0;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-video-heading"] && !Shopify.designMode) return;
  try {
    (function () {
  var BLOCK_SEL = '[data-pvh]';
  /* A real Whatmore tile exists as soon as the carousel mounts — keying off the
     "Play video" button (present even before the <video> element loads) or a
     <video> is template-agnostic and survives Whatmore markup changes. */
  var VIDEO_SEL = 'video, [aria-label^="Play video"], .whatmore-video-player-muted';
  var WAIT_MS = 5000;

  function inDesignMode() {
    return !!(window.Shopify && window.Shopify.designMode);
  }

  function hasVideos(el) {
    return !!(el && el.querySelector(VIDEO_SEL));
  }

  function reveal(root) {
    root.classList.remove('pvh--pending');
    root.classList.add('pvh--ready');
  }

  /* The Whatmore widget renders as a bare sibling right after this block.
     Find the first following sibling that looks like an app block (or already
     contains a Whatmore carousel); fall back to the immediate next element. */
  function carouselSibling(root) {
    var el = root.nextElementSibling;
    while (el) {
      var isApp = el.matches && el.matches('.shopify-app-block, .shopify-block');
      var hasWhatmore = el.querySelector && el.querySelector('.whatmore-base, [aria-label^="Play video"]');
      if (isApp || hasWhatmore) { return el; }
      el = el.nextElementSibling;
    }
    return root.nextElementSibling;
  }

  function init(root) {
    if (!root || root.dataset.pvhInit === '1') { return; }
    root.dataset.pvhInit = '1';

    // Never hide in the editor — the merchant must be able to select it.
    if (inDesignMode()) { reveal(root); return; }
    if (root.getAttribute('data-hide-when-empty') !== 'true') { reveal(root); return; }

    var target = carouselSibling(root);
    if (!target) { reveal(root); return; } // nothing below to watch → show heading
    if (hasVideos(target)) { reveal(root); return; }

    var done = false;
    var timer = null;
    var io = null;
    var observer = new MutationObserver(function () {
      if (hasVideos(target)) { settle(true); }
    });

    function settle(found) {
      if (done) { return; }
      done = true;
      observer.disconnect();
      if (io) { io.disconnect(); }
      if (timer) { clearTimeout(timer); }
      if (found) {
        reveal(root);
      } else {
        // Collapse the heading and the empty carousel below it.
        root.style.display = 'none';
        if (target) { target.style.display = 'none'; }
      }
    }

    function startWatching() {
      if (timer) { return; }
      observer.observe(target, { childList: true, subtree: true });
      timer = setTimeout(function () { settle(hasVideos(target)); }, WAIT_MS);
    }

    /* Whatmore lazy-loads, so don't judge it "empty" before it's near view. */
    if ('IntersectionObserver' in window) {
      io = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) { startWatching(); break; }
        }
      }, { rootMargin: '600px 0px' });
      io.observe(root);
    } else {
      startWatching();
    }
  }

  function initAll(scope) {
    var nodes = (scope || document).querySelectorAll(BLOCK_SEL);
    for (var i = 0; i < nodes.length; i++) { init(nodes[i]); }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["size-selector"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('size-selector')) {
    customElements.define('size-selector', class extends HTMLElement {
      connectedCallback() {
        this.trigger = this.querySelector('[data-size-selector-trigger]');
        this.panel = this.querySelector('[data-size-selector-panel]');
        this.searchInput = this.querySelector('[data-size-selector-search]');
        this.triggerText = this.querySelector('[data-size-selector-trigger-text]');
        this.selectedLabel = this.querySelector('[data-size-selector-selected]');
        this.emptyEl = this.querySelector('[data-size-selector-empty]');
        this.showSelected = this.getAttribute('data-show-selected') === 'true';

        this._onDocClick = (e) => { if (!this.contains(e.target)) this.close(); };

        this.addEventListener('change', (e) => {
          if (e.target.matches('[data-variant-input]')) this.onSelect(e.target.value);
        });

        if (this.trigger) {
          this.trigger.addEventListener('click', () => this.toggle());
          this.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && this.panel && !this.panel.hidden) {
              this.close();
              this.trigger.focus();
            }
          });
        }
        if (this.searchInput) {
          this.searchInput.addEventListener('input', () => this.filter(this.searchInput.value));
        }

        var checked = this.querySelector('[data-variant-input]:checked');
        if (checked) this.onSelect(checked.value, true);
      }

      disconnectedCallback() { document.removeEventListener('click', this._onDocClick); }

      toggle() { (this.panel && this.panel.hidden) ? this.open() : this.close(); }

      open() {
        if (!this.panel) return;
        this.panel.hidden = false;
        if (this.trigger) this.trigger.setAttribute('aria-expanded', 'true');
        document.addEventListener('click', this._onDocClick);
        if (this.searchInput) { this.searchInput.value = ''; this.filter(''); this.searchInput.focus(); }
      }

      close() {
        if (!this.panel) return;
        this.panel.hidden = true;
        if (this.trigger) this.trigger.setAttribute('aria-expanded', 'false');
        document.removeEventListener('click', this._onDocClick);
      }

      onSelect(value, silent) {
        if (this.triggerText) {
          this.triggerText.textContent = value;
          this.triggerText.classList.remove('is-placeholder');
        }
        if (this.selectedLabel) this.selectedLabel.innerHTML = this.showSelected ? ' &mdash; ' + value : '';
        if (!silent) this.close();
      }

      filter(query) {
        query = (query || '').trim().toLowerCase();
        var any = false;
        this.querySelectorAll('[data-size-value]').forEach(function (cell) {
          var match = !query || cell.getAttribute('data-size-value').indexOf(query) !== -1;
          cell.hidden = !match;
          if (match) any = true;
        });
        if (this.emptyEl) this.emptyEl.hidden = any;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sticky-atc-bar"] && !Shopify.designMode) return;
  try {
    (function() {
  'use strict';

  function initStickyBar(sectionEl) {
    var bar = sectionEl.querySelector('[data-sticky-atc-bar]');
    if (!bar) return null;

    var mainAtcBtn = sectionEl.querySelector('[data-add-to-cart]');
    // When a custom observe selector is set (e.g. FoxSell bundle pages that have
    // no standard buy_buttons block), mainAtcBtn may be null — that is expected.
    var observeSelector = bar.getAttribute('data-observe-selector') || null;
    if (!mainAtcBtn && !observeSelector) return null;

    // ── 1. Visibility via IntersectionObserver ────────────────────
    // data-observe-selector lets a button in another section (e.g. FoxSell's
    // bundle ATC) act as the show/hide trigger instead of [data-add-to-cart].
    // A MutationObserver fallback handles app blocks that render asynchronously.
    var mobileBarEl = bar.querySelector('.sticky-atc-bar__mobile');
    var stickyAtc = bar.querySelector('[data-sticky-atc]');
    var stickyAtcMobile = bar.querySelector('[data-sticky-atc-mobile]');
    var selectorWatcher = null;
    var attrWatcher = null;

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        var visible = !entry.isIntersecting;
        bar.classList.toggle('is-visible', visible);
        bar.setAttribute('aria-hidden', String(!visible));

        // Lift wishlist icon above bar on mobile
        if (window.innerWidth <= 599) {
          if (visible && mobileBarEl) {
            document.documentElement.style.setProperty(
              '--sticky-bar-h', mobileBarEl.offsetHeight + 'px'
            );
            document.body.classList.add('sticky-atc-visible');
          } else {
            document.body.classList.remove('sticky-atc-visible');
          }
        }
      });
    }, { threshold: 0 });

    // Mirror the observe-target's disabled state to our sticky buttons.
    // FoxSell's bundle ATC starts disabled until all selections are made.
    // Uses data-observe-disabled (not native disabled) so click events still
    // fire — allowing us to scroll to the bundle section when not ready.
    function setObserveDisabled(dis) {
      if (stickyAtc) {
        stickyAtc.setAttribute('data-observe-disabled', String(dis));
        stickyAtc.setAttribute('aria-disabled', String(dis));
      }
      if (stickyAtcMobile) {
        stickyAtcMobile.setAttribute('data-observe-disabled', String(dis));
        stickyAtcMobile.setAttribute('aria-disabled', String(dis));
      }
    }

    function syncObserveTargetState(el) {
      setObserveDisabled(el.disabled);

      if (attrWatcher) { attrWatcher.disconnect(); }
      attrWatcher = new MutationObserver(function() {
        var t = document.querySelector(observeSelector);
        if (t) setObserveDisabled(t.disabled);
      });
      attrWatcher.observe(el, { attributes: true, attributeFilter: ['disabled'] });
    }

    function startObserving(el) {
      observer.observe(el);
      if (observeSelector) syncObserveTargetState(el);
    }

    if (observeSelector) {
      var customTarget = document.querySelector(observeSelector);
      if (customTarget) {
        startObserving(customTarget);
      } else {
        // Element not yet in DOM — watch for the app block to finish rendering
        selectorWatcher = new MutationObserver(function() {
          var el = document.querySelector(observeSelector);
          if (el) {
            selectorWatcher.disconnect();
            selectorWatcher = null;
            startObserving(el);
          }
        });
        selectorWatcher.observe(document.body, { childList: true, subtree: true });
      }
    } else {
      startObserving(mainAtcBtn);
    }

    // ── 2. ATC click delegation ───────────────────────────────────
    function handleAtcClick(e) {
      e.preventDefault();
      if (mainAtcBtn) {
        mainAtcBtn.click();
      } else if (observeSelector) {
        var target = document.querySelector(observeSelector);
        if (!target) return;
        if (target.disabled) {
          // Bundle not yet fully configured — scroll to it so user can make selections
          target.scrollIntoView({ behavior: 'smooth', block: 'center' });
        } else {
          target.click();
        }
      }
    }

    if (stickyAtc) stickyAtc.addEventListener('click', handleAtcClick);
    if (stickyAtcMobile) stickyAtcMobile.addEventListener('click', handleAtcClick);

    // ── 3. Variant sync: main form → sticky bar ───────────────────
    var stickyPrice = bar.querySelector('[data-sticky-price]');
    var stickyVariantText = bar.querySelector('[data-sticky-variant-text]');
    var stickyAtcText = bar.querySelector('[data-sticky-atc-text]');
    var stickyAtcMobileText = bar.querySelector('[data-sticky-atc-mobile-text]');
    var stickySelects = bar.querySelectorAll('[data-sticky-option-index]');
    var mobilePriceEl = bar.querySelector('[data-sticky-mobile-price]');
    var mobileSelect = bar.querySelector('[data-sticky-mobile-select]');

    function syncBarToVariant(variant) {
      // Price — use variant.price from event detail to avoid DOM-read timing dependency.
      // Fallback to DOM read only when no variant object is available.
      var formattedPrice = null;
      if (variant && variant.price !== undefined) {
        formattedPrice = theme.Currency.formatMoney(variant.price, theme.settings.moneyFormat);
      } else {
        var priceEl = sectionEl.querySelector('[data-product-price]');
        if (priceEl) formattedPrice = priceEl.textContent.trim();
      }
      if (formattedPrice !== null) {
        if (stickyPrice) stickyPrice.textContent = formattedPrice;
        if (mobilePriceEl) mobilePriceEl.textContent = formattedPrice;
      }

      // Button text — read from the theme's updated button label
      var mainBtnTextEl = sectionEl.querySelector('[data-add-to-cart-text]');
      var btnText = mainBtnTextEl ? mainBtnTextEl.textContent.trim() : '';
      if (stickyAtcText) stickyAtcText.textContent = btnText;
      if (stickyAtcMobileText) stickyAtcMobileText.textContent = btnText;

      // Variant title + dropdown sync — use passed variant object (from event detail)
      // Fallback to [data-current-variant-json] on initial page load (no event yet)
      if (!variant) {
        var variantJsonEl = sectionEl.querySelector('[data-current-variant-json]');
        if (variantJsonEl) {
          try { variant = JSON.parse(variantJsonEl.textContent); } catch(err) {}
        }
      }

      if (variant) {
        if (stickyVariantText) {
          stickyVariantText.textContent = variant.title && variant.title !== 'Default Title'
            ? '\u00a0\u00b7\u00a0' + variant.title
            : '';
        }

        if (variant.options) {
          stickySelects.forEach(function(select, i) {
            if (variant.options[i] !== undefined) {
              select.value = variant.options[i];
            }
          });
        }

        // Merged mobile select — sync to selected variant (String cast: select.value is always a string)
        if (mobileSelect) {
          mobileSelect.value = String(variant.id);
        }
      }

      // Availability — only mirror native disabled for standard (non-observe) products.
      // For observe-selector products (FoxSell), state is kept in sync by attrWatcher.
      if (mainAtcBtn) {
        var isDisabled = mainAtcBtn.disabled;
        if (stickyAtc) {
          stickyAtc.disabled = isDisabled;
          stickyAtc.setAttribute('aria-disabled', String(isDisabled));
        }
        if (stickyAtcMobile) {
          stickyAtcMobile.disabled = isDisabled;
          stickyAtcMobile.setAttribute('aria-disabled', String(isDisabled));
        }
      }
    }

    // Listen to variant:change on document (dispatched by theme.js after all sync
    // state updates — button text, availability — are already applied).
    // Price is read directly from variant.price so no DOM-read timing dependency.
    function onVariantChange(e) {
      var variant = e.detail && e.detail.variant;
      syncBarToVariant(variant);
    }
    document.addEventListener('variant:change', onVariantChange);

    // ── 4. Desktop dropdown → main form ──────────────────────────
    // Write matched variant options to [data-variant-input] elements and dispatch
    // change on option1 — this triggers theme.Variants._onSelectChange which runs
    // the full variant pipeline (image swap, price, history state, etc.).
    var allVariantsEl = sectionEl.querySelector('[data-variant-json]');

    stickySelects.forEach(function(select) {
      select.addEventListener('change', function() {
        if (!allVariantsEl) return;

        var selectedValues = [];
        stickySelects.forEach(function(s) { selectedValues.push(s.value); });

        var variants;
        try { variants = JSON.parse(allVariantsEl.textContent); } catch(e) { return; }

        var match = null;
        for (var i = 0; i < variants.length; i++) {
          var v = variants[i];
          if (v.options.every(function(opt, idx) { return opt === selectedValues[idx]; })) {
            match = v; break;
          }
        }
        if (!match) return;

        match.options.forEach(function(optionValue, idx) {
          var inputs = sectionEl.querySelectorAll('[data-variant-input][data-index="option' + (idx + 1) + '"]');
          inputs.forEach(function(input) {
            if (input.tagName === 'SELECT') input.value = optionValue;
            else input.checked = (input.value === optionValue);
          });
        });

        var firstInput = sectionEl.querySelector('[data-variant-input][data-index="option1"]');
        if (firstInput) firstInput.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });

    // ── 4b. Mobile merged select → main form ─────────────────────
    function onMobileSelectChange() {
      if (!allVariantsEl) return;

      var variants;
      try { variants = JSON.parse(allVariantsEl.textContent); } catch(e) { return; }

      var selectedId = parseInt(mobileSelect.value, 10);
      var match = null;
      for (var i = 0; i < variants.length; i++) {
        if (variants[i].id === selectedId) { match = variants[i]; break; }
      }
      if (!match) return;

      match.options.forEach(function(optionValue, idx) {
        var inputs = sectionEl.querySelectorAll('[data-variant-input][data-index="option' + (idx + 1) + '"]');
        inputs.forEach(function(input) {
          if (input.tagName === 'SELECT') {
            input.value = optionValue;
          } else {
            input.checked = (input.value === optionValue);
          }
        });
      });

      var firstInput = sectionEl.querySelector('[data-variant-input][data-index="option1"]');
      if (firstInput) {
        firstInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
    if (mobileSelect) mobileSelect.addEventListener('change', onMobileSelectChange);

    // ── Cleanup ───────────────────────────────────────────────────
    return function cleanup() {
      observer.disconnect();
      if (selectorWatcher) { selectorWatcher.disconnect(); selectorWatcher = null; }
      if (attrWatcher) { attrWatcher.disconnect(); attrWatcher = null; }
      document.removeEventListener('variant:change', onVariantChange);
      if (mobileSelect) mobileSelect.removeEventListener('change', onMobileSelectChange);
      document.body.classList.remove('sticky-atc-visible');
    };
  }

  // ── Theme editor events ───────────────────────────────────────────
  var cleanups = {};

  document.addEventListener('shopify:section:load', function(e) {
    var id = e.target.id;
    if (cleanups[id]) { cleanups[id](); }
    cleanups[id] = initStickyBar(e.target);
  });

  document.addEventListener('shopify:section:unload', function(e) {
    var id = e.target.id;
    if (cleanups[id]) { cleanups[id](); delete cleanups[id]; }
  });

  // ── Initial page load ─────────────────────────────────────────────
  document.querySelectorAll('[data-section-type="product"]').forEach(function(el) {
    cleanups[el.id] = initStickyBar(el);
  });

})();
  } catch(e) { console.error(e); }
})();

})();
